export function capitalizeFirstLetter (s) {
  const firstLetter = s.charAt(0).toUpperCase()
  return `${firstLetter}${s.slice(1)}`
}
